var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174,
    height: 223,
    viewBox: "0 0 174 223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#2CABE0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-423 -469) translate(0 80) translate(423 389)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 171,
    height: 220,
    x: 1.5,
    y: 1.5,
    fill: "#FFF",
    strokeWidth: 3,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 123,
    x: 78.5,
    y: -3.5,
    fill: "#FFF",
    strokeWidth: 3,
    rx: 5,
    transform: "rotate(90 87 58)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 123,
    x: 78.5,
    y: 26.5,
    fill: "#FFF",
    strokeWidth: 3,
    rx: 5,
    transform: "rotate(90 87 88)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 123,
    x: 78.5,
    y: 56.5,
    fill: "#FFF",
    strokeWidth: 3,
    rx: 5,
    transform: "rotate(90 87 118)"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0.5L2.5 4.5",
    transform: "translate(155 116)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0.5L2.5 4.5",
    transform: "translate(155 116) rotate(90 2.5 2.5)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.75a644872339b294e8aad0e64436dbfa.svg";
export { ForwardRef as ReactComponent };